export enum PosthogEventName {
  //engagementflow
  FlowWidgetClicked = 'engagementflow.chatwidgetClicked',

  // common
  WidgetClicked = 'engagementhub.widgetClicked',
  Expanded = 'engagementhub.expanded',
  Minimized = 'engagementhub.minimized',
  ToUClicked = 'engagementhub.ToUClicked',
  PPClicked = 'engagementhub.PPClicked',
  BackButtonClicked = 'engagementhub.backButtonClicked',
  CloseButtonClicked = 'engagementhub.closeButtonClicked', // we have a Minimize event for this already...
  LandingPageView = 'engagementhub.landingPage.view',
  LandingPageSearchInputClicked = 'engagementhub.landingPage.searchInputClicked',
  LandingPageLiveChatClicked = 'engagementhub.landingPage.livechatClicked',
  LandingPageVirtualChatClicked = 'engagementhub.landingPage.virtualchatClicked',
  LandingPageLinkClicked = 'engagementhub.landingPage.linkClicked',
  LandingPageCategoryClicked = 'engagementhub.landingPage.categoryClicked',
  LandingPageCTAClicked = 'engagementhub.landingPage.CTAClicked',
  LandingPageLogoClicked = 'engagementhub.landingPage.logoClicked',
  LandingPagePillClicked = 'engagementhub.landingPage.pillClicked',
  ContactClicked = 'engagementhub.contactClicked',
  ISIClicked = 'engagementhub.ISIClicked',
  GlobalISIClicked = 'engagementhub.ISIClicked', // not used so far
  CallButtonClicked = 'engagementhub.callButtonClicked',
  HalfOpen = 'engagementhub.landingPage.halfopen',
  HalfOpenExpanded = 'engagementhub.halfOpen.expanded',

  // search (FAQ)
  LoadSearchScreen = 'engagementhub.search.searchScreen',
  SearchQueryLoad = 'engagementhub.search.queryReturned',

  // SearchTopicClicked = 'engagementhub.search.TopicClicked',
  TopicScreenView = 'engagementhub.search.TopicScreen.View',
  TopicScreenBackButton = 'engagementhub.search.TopicScreen.BackButton',
  TopicScreenLinkClicked = 'engagementhub.search.TopicScreen.LinkClicked',
  TopicScreenButtonClicked = 'engagementhub.search.TopicScreen.ButtonClicked',
  TopicScreenTopicClicked = 'engagementhub.search.TopicClicked',
  SearchClosed = 'engagementhub.search.searchClosed',
  ResourceDownloaded = 'engagementhub.search.ResourceDownloaded',
  QuerySubmitted = 'engagementhub.search.querySubmitted',
  // SearchInterstitialTopicClicked = 'engagementhub.search.interstitialTopicClicked',
  SearchInterstitialCTAClicked = 'engagementhub.search.interstitialCTAClicked',

  //Video
  VideoPlayed = 'engagementhub.search.VideoPlayed',
  VideoProgressed = 'engagementhub.search.VideoProgressed',
  VideoPaused = 'engagementhub.search.VideoPaused',
  VideoEnded = 'engagementhub.search.VideoEnded',

  // VA
  VirtualChatPageview = 'engagementhub.virtualchat.pageview',
  VirtualChatOptionPresented = 'engagementhub.virtualchat.optionPresented',
  VirtualChatOptionclick = 'engagementhub.virtualchat.optionclick',
  VirtualChatVAMessageSent = 'engagementhub.virtualchat.VAMessageSent',
  VirtualChatLinkClicked = 'engagementhub.virtualchat.linkClicked',
  VirtualChaUserDataSubmitted = 'engagementhub.virtualchat.userDataSubmitted',
  VirtualChatUserDataSkipped = 'engagementhub.virtualchat.userDataSkipped',
  VirtualChatLocationFinderResult = 'engagementhub.virtualchat.locationFinderResult',
  VirtualChatLocationFinderResultClick = 'engagementhub.virtualchat.locationFinder.resultClick',

  // live chat
  LiveChatStartScreen = 'engagementhub.livechat.startScreen',
  LiveChatLinkClicked = 'engagementhub.livechat.linkClicked',
  LiveChatTermsChecked = 'engagementhub.livechat.termsChecked',
  LiveChatTermsAccepted = 'engagementhub.livechat.termsAccepted',
  LiveChatChatScreen = 'engagementhub.livechat.chatScreen',
  LiveChatOptionsPresented = 'engagementhub.livechat.optionsPresented',
  LiveChatOptionClicked = 'engagementhub.livechat.optionClicked',
  LiveChatContactRequested = 'engagementhub.livechat.contactRequested',
  LiveChatContactSubmitted = 'engagementhub.livechat.contactSubmitted',
  LiveChatContactSkipped = 'engagementhub.livechat.contactSkipped',
  LiveChatMessageTyped = 'engagementhub.livechat.messageTyped',
  LiveChatUserMessageSent = 'engagementhub.livechat.UserMessageSent',
  LiveChatAgentMessageSent = 'engagementhub.livechat.agentMessageSent',
  LiveChatDisclaimerPresented = 'engagementhub.livechat.DisclaimerPresented',
  LiveChatSessionNurseJoined = 'engagementhub.livechat.chatSessionNurseJoined',
  LiveChatDisclaimerExpanded = 'engagementhub.livechat.DisclaimerExpanded',
  LiveChatHalfOpen = 'engagementhub.livechat.halfopen',

  // ai chat
  AIChatQuerySubmitted = 'engagementhub.aichat.querySubmitted',
  RelatedResourcesClicked = 'engagementhub.integratedResultsPage.relatedResourceClicked',
  TopicSourceClicked = 'engagementhub.integratedResultsPage.topicSourceClicked',

  // SMS link
  TwilioSMSLinkClicked = 'twilioSMS.linkClicked',

  // Language
  LanguageSelectorClicked = 'engagementhub.languageSelectorClicked',

  // Suggested article
  SuggestedTopicAppearance = 'engagementhub.search.nba.SuggestedTopicAppearance',
  SuggestedTopicClicked = 'engagementhub.search.nba.SuggestedTopicClicked',
  SuggestedTopicClosed = 'engagementhub.search.nba.SuggestedTopicClosed',

  // TAIlor
  ToggleOpenCalled = 'engagementhub.toggleOpenCalled',
  ReloadWithIdCalled = 'engagementhub.reloadWithIdCalled',
  ScrollDepth = 'engagementhub.scrolldepth',

  // Contact form
  ContactFormOpened = 'engagementhub.contactform.opened',
  ContactFormView = 'engagementhub.contactform.view',
  ContactFormContinue = 'engagementhub.contactform.continue',
  ContactFormClosed = 'engagementhub.contactform.closed',
  ContactFormComplete = 'engagementhub.contactform.complete',
  ContactFormError = 'engagementhub.contactform.error',
  ContactFormCheckbox = 'engagementhub.contactform.checkboxChanged',

  // Indication selector
  IndicationMenuOpened = 'engagementhub.indicationSelector.IndicationMenuOpened',
  IndicationChanged = 'engagementhub.indicationSelector.IndicationChanged',

  // Widget Button
  WidgetButtonLoaded = 'widgetButtonLoaded',
}
